<template>
    <div id="summary">
        <div class="app-container mt-5 mb-5" v-if="!$global.loading">
            <div class="d-flex justify-content-between mb-5">
                <div class="d-flex">
                    <div class="category-btn mr-3" v-if="provider.last_not_drafted_version.category">
                        {{ provider.last_not_drafted_version.category.label }}
                    </div>

                    <div class="page-title mr-3" v-if="provider.referent_data">
                        {{ provider.referent_data.name }}
                    </div>
                    <div class="page-title mr-3"
                         v-else-if="provider.last_not_drafted_version">
                        {{ provider.last_not_drafted_version.name }}
                    </div>

                    <div v-if="provider.apidae_source">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" :href="provider.apidae_source.url" target="_blank"
                                       class="shadow-none">
                                    <v-icon>open_in_new</v-icon>
                                </v-btn>
                            </template>
                            <span>Voir sur Apidae</span>
                        </v-tooltip>
                    </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div v-if="isCampaignAvailable('CMAJ') && provider.last_not_drafted_version.category">
                        <v-btn outlined class="custom-button-primary" @click="displayConfirmBeforeModal">
                            <v-icon left>send</v-icon>
                            Envoyer une demande d'informations individuelle
                        </v-btn>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="gap-15 d-flex flex-column">
                        <information-bloc v-if="account.tis_type.code !== 'NO_SIT'"
                                          :provider-id="providerId" :open-form-url="openFormUrl">
                        </information-bloc>
                        <div class="d-flex flex-row">
                            <contact-bloc :contact="contact" :providerId="providerId"
                                          :providerSelectionsCount="belongsToSelection" :provider="provider"
                                          class="col-6 p-0 mr-2 h-auto">
                            </contact-bloc>
                            <tag-bloc :provider-id="providerId" class="col-6 ml-2 h-auto"></tag-bloc>
                        </div>

                        <entity-bloc :provider-id="providerId" :entity="sitEntity"
                                     v-if="account.tis_type.code === 'DAHUB_QUEBEC' && account.id === 252">
                        </entity-bloc>
                        <note-bloc :provider-id="providerId"></note-bloc>
                        <selection-bloc :provider-id="providerId" v-if="account.tis_type.code === 'APIDAE'">
                        </selection-bloc>
                    </div>
                </div>
                <div class="col-6 gap-15 d-flex flex-column">
                    <campaign-bloc :provider-id="providerId"></campaign-bloc>
                    <comment-and-phone-bloc :provider-id="providerId"></comment-and-phone-bloc>
                    <history-bloc :actions="actions" :provider="provider"></history-bloc>
                </div>
            </div>
        </div>

        <create-unique-form-modal ref="modale"></create-unique-form-modal>
        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import CreateUniqueFormModal from "../../campaign/cmaj/CreateUniqueFormModal"
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm"
import NoteBloc from "./NoteBloc"
import CommentAndPhoneBloc from "./CommentAndPhoneBloc"
import HistoryBloc from "./HistoryBloc"
import TagBloc from "./TagBloc"
import CampaignBloc from "./CampaignBloc"
import ContactBloc from "./ContactBloc"
import SelectionBloc from "./SelectionBloc.vue"
import InformationBloc from "./InformationBloc.vue"
import EntityBloc from "./EntityBloc.vue"

export default {
    name: "Summary",
    components: {
        ContactBloc,
        CampaignBloc,
        TagBloc,
        HistoryBloc,
        CommentAndPhoneBloc,
        NoteBloc,
        Confirm,
        CreateUniqueFormModal,
        SelectionBloc,
        InformationBloc,
        EntityBloc,
    },
    data() {
        return {
            providerId: null,
            provider: {
                last_not_drafted_version: {
                    category: null,
                    name: "",
                },
                referent_data: null,
            },
            actions: [],
            contact: { profession: null },
            tabulations: [],
            isLg: true,
            belongsToSelection: false,
            openFormUrl: null,
            informationData: null,
            sitEntity: null,
            waitingCmajsCount: 0,
            waitingIndividualSollicitationsCount: 0,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["resetState", "setCurrentStep"]),
        getProvider() {
            this.$global.loading = true
            this.$http.get("auth/providers/" + this.providerId).then(res => {
                this.provider = res.body.data.provider
                this.contact = res.body.data.provider.contact
                this.belongsToSelection = res.body.data.belongsToSelection
                this.sitEntity = res.body.data.sitEntity
                this.waitingCmajsCount = res.body.data.cmajCount
                this.waitingIndividualSollicitationsCount = res.body.data.individualSollicitationsCount

               // this.getFields(this.provider.last_not_drafted_version.category.name)

                this.$global.loading = false
            })
        },
        getFields(categoryName) {
            this.$http.get("auth/account/referential/category-fields/" + categoryName).then(res => {
                this.tabulations = res.body.data.fields
            })
        },
        getActions() {
            this.$http.get("auth/providers/" + this.providerId + "/actions").then(res => {
                this.actions = res.body.data.actions
            })
        },
        setOpenModal() {
            this.$global.loading = true
            let categoryName = this.provider.last_not_drafted_version.category.label
            this.$http.get("auth/account/referential/category-fields/" + categoryName).then(res => {
                this.tabulations = res.body.data.fields
                this.setCurrentStep(1)

                this.$refs.modale.open(this.tabulations, this.contact, this.provider)
            })
            this.$global.loading = false

            // this.setCurrentStep(1)
            //
            // this.$refs.modale.open(this.tabulations, this.contact, this.provider)
        },
        displayConfirmBeforeModal() {
            if(this.waitingCmajsCount > 0 || this.waitingIndividualSollicitationsCount > 0) {
                let message = '<strong>Une ou des sollicitations sont déjà en cours.</strong> <br>'
                if(this.waitingCmajsCount > 0 && this.waitingIndividualSollicitationsCount === 0) {
                    message += 'Ce prestataire est déjà présent dans <strong>' + this.waitingCmajsCount + '</strong> campagne(s).<br>'
                } else if(this.waitingIndividualSollicitationsCount > 0 && this.waitingCmajsCount === 0) {
                    message += 'Ce prestataire a déjà reçu <strong>' + this.waitingIndividualSollicitationsCount +
                      '</strong> demande(s) individuelle(s).<br>'
                } else if(this.waitingIndividualSollicitationsCount > 0 && this.waitingCmajsCount > 0) {
                    message += 'Ce prestataire est déjà présent dans <strong>' + this.waitingCmajsCount + '</strong> campagne(s) en cours' +
                      ' et a déjà reçu <strong>' + this.waitingIndividualSollicitationsCount + '</strong> demande(s) individuelle(s).<br>'
                }

                message += '<br>' + 'Êtes-vous sûr de vouloir envoyer une nouvelle demande individuelle ?'

                this.$refs.confirm.open('Prestataire déjà sollicité',
                  message +'<br>',
                  { confirmColor: 'primary', cancelColor: '#0b697e' }).then((confirm) => {
                    if(confirm) {
                        this.setOpenModal()
                    }
                })
            } else {
                this.setOpenModal()
            }
        },
        findBootstrapEnvironment() {
            let envs = ["xs", "sm", "md", "lg", "xl"]

            let el = document.createElement("div")
            document.body.appendChild(el)

            let curEnv = envs.shift()

            for (let env of envs.reverse()) {
                el.classList.add(`d-${env}-none`)

                if (window.getComputedStyle(el).display === "none") {
                    curEnv = env
                    break
                }
            }

            document.body.removeChild(el)

            this.isLg = ["lg", "xl"].includes(curEnv)
        },
        isCampaignAvailable(code) {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === code)

                    if (module.length) {
                        available = true
                    }
                })
            }
            return available
        },
    },
    computed: {
        ...mapState("account", ["user", "account"]),
    },
    created() {
        this.$global.loading = true
        let hash = this.$route.params.hash
        this.providerId = parseInt(atob(hash))

        this.getProvider()
        this.getActions()

        this.findBootstrapEnvironment()

        window.addEventListener("resize", this.findBootstrapEnvironment)

        this.$global.$on("reload-summary", () => {
            this.$global.loading = true
            this.getProvider()
            this.getActions()

            this.$refs.modale.cancel()
        })

        this.openFormUrl = "/sit/formulaire/" + this.providerId
    },
    beforeDestroy() {
        this.$global.$off("reload-summary")

        window.removeEventListener("resize", this.findBootstrapEnvironment)
    },
}
</script>